import { gql } from "graphql-tag";

export const GET_PLANS_ALL = gql`
  query plansAll {
    plansAll {
      id
      name
      description
      isPublic
      defaultPricingId
      invoicedPlanIds {
        annually
        quarterly
      }
      insertedAt
      updatedAt
      defaultPricing {
        id
        pricingTypeId
        thresholdTypeId
        minimumPrice
        unitThreshold
        annualDiscountPercent
        monthlyPricePerUnit
        pricingType {
          id
          name
        }
        thresholdType {
          id
          name
        }
      }
    }
  }
`;

export const GET_PLAN_PRICING_QUOTE = gql`
  query planPricingQuote(
    $planId: ID!
    $billingCycle: String!
    $unitCount: Int!
  ) {
    planPricingQuote(
      planId: $planId
      billingCycle: $billingCycle
      unitCount: $unitCount
    ) {
      monthlyRecurring
      annualEquivalentTotal
      annualDiscountPercent
      monthlyBeforeDiscount
      annualPaymentDiscountAmount
      oneTimeSetupFee
    }
  }
`;

export const GET_PLAN_BY_ID = gql`
  query plan($id: ID!) {
    plan(id: $id) {
      id
      name
      description
      isPublic
      defaultPricingId
      invoicedPlanIds {
        annually
        quarterly
      }
      insertedAt
      updatedAt
      defaultPricing {
        id
        pricingTypeId
        thresholdTypeId
        minimumPrice
        unitThreshold
        annualDiscountPercent
        monthlyPricePerUnit
        pricingType {
          id
          name
        }
        thresholdType {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation createPlan($data: PlanInput!) {
    createPlan(data: $data) {
      id
      name
      description
      isPublic
      defaultPricingId
      invoicedPlanIds {
        annually
        quarterly
      }
      insertedAt
      updatedAt
      defaultPricing {
        id
        pricingTypeId
        thresholdTypeId
        minimumPrice
        unitThreshold
        annualDiscountPercent
        monthlyPricePerUnit
        pricingType {
          id
          name
        }
        thresholdType {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_PLAN = gql`
  mutation updatePlan($id: ID!, $data: PlanUpdateInput!) {
    updatePlan(id: $id, data: $data) {
      id
      name
      description
      isPublic
      defaultPricingId
      invoicedPlanIds {
        annually
        quarterly
      }
      insertedAt
      updatedAt
      defaultPricing {
        id
        pricingTypeId
        thresholdTypeId
        minimumPrice
        unitThreshold
        annualDiscountPercent
        monthlyPricePerUnit
        pricingType {
          id
          name
        }
        thresholdType {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_PLAN = gql`
  mutation deletePlan($id: ID!) {
    deletePlan(id: $id) {
      id
    }
  }
`;

export const GET_PRICING_ALL_FOR_PLANS = gql`
  query pricingAllForPlans {
    pricingAll {
      id
      pricingTypeId
      thresholdTypeId
      minimumPrice
      unitThreshold
      annualDiscountPercent
      monthlyPricePerUnit
      pricingType {
        id
        name
      }
      thresholdType {
        id
        name
      }
    }
  }
`;
